import React, { useState, useEffect } from 'react'
import { ButtonWhiteTwo } from '../Buttons/ButtonWhiteTwo'
import './customPagination.css';
import { t } from 'i18next';

const CustomPagination = ({ totalPages, page, setPage, disabled = false }) => {
    const prevPageDisabled = (page === 1) || disabled;

    const nextPageDisabled = (page === totalPages) || disabled;

    const [localPage, setLocalPage] = useState(page);

    const onKeyPress = (e) => {
        if (e.key === 'Enter' && !!String(localPage).trim() && Number(localPage) <= totalPages) {
            setPage(Number(localPage));
        }
    }

    useEffect(() => {
        setLocalPage(page);
    }, [page])

    return (
        <div className='d-flex align-items-center gap-2'>
            <span>{t('PAGE')}</span>
            <input
                type="number"
                name="page"
                className='form-control custom-number-input fw-bold'
                style={{ width: '40px' }}
                value={localPage}
                max={totalPages}
                min={1}
                onKeyPress={onKeyPress}
                onChange={(e) => setLocalPage(e.target.value)}
                disabled={totalPages === 1 || disabled}
            />
            <span>{t('OF')} <strong>{totalPages}</strong></span>
            <div className='d-flex border rounded-3'>
                <ButtonWhiteTwo
                    className='rounded-start'
                    disabled={prevPageDisabled}
                    onClick={() => setPage(page - 1)}
                >
                    <i
                        style={{ color: prevPageDisabled ? 'var(--gray-500)' : 'var(--new-orange)' }}
                        className="fa-solid fa-chevron-left fw-bold"
                    >
                    </i>
                </ButtonWhiteTwo>
                <ButtonWhiteTwo
                    className='rounded-end'
                    disabled={nextPageDisabled}
                    onClick={() => setPage(page + 1)}
                >
                    <i
                        style={{ color: nextPageDisabled ? 'var(--gray-500)' : 'var(--new-orange)' }}
                        className="fa-solid fa-chevron-right fw-bold"
                    >
                    </i>
                </ButtonWhiteTwo>
            </div>
        </div>
    )
}

export default CustomPagination